if(sessionStorage.getItem('closed')){
  document.getElementById('modal_popup').style.display="none";
};

function onPopupLoad() {
  const myPopup = document.getElementById('modal_popup');
  if(!myPopup) return;
  myPopup.classList.add('is-show');
    
  const closePopupElement = document.getElementsByClassName('js-modal-close');
  for( let i = 0; i < closePopupElement.length; i++ ) {
    closePopup(closePopupElement[i]);
  }

  function closePopup(element) {
    if(!element) return;
    element.addEventListener('click', function() {
      myPopup.classList.remove('is-show');
      sessionStorage.setItem('closed', 'close');
    })
  }
  
}

window.addEventListener('DOMContentLoaded', onPopupLoad );